import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import AddBrand from "../../Modals/addbrand";
import SwitchToggle from "../../components/SwitchToggle";

const ManageBrands = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBrandId, setSelectedBrandId] = useState<number | null>(1);
  const [expandedRow, setExpandedRow] = useState<number | null>(null);
  const [rows] = useState([
    {
      id: 1,
      name: "Adidas",
      logo: "",
      description: "Global sports brand for athletic wear and shoes.",
      products: 120,
      website: "https://adidas.com",
      status: "Active",
      featured: false,
      owner: "Vendor",
      vendorName: "SportsHub Intl.",
      verificationStatus: "Verified",
      allowedCategories: ["Footwear", "Apparel"],
      restrictedCategories: ["Fragrances"],
      isInternalOnly: false,
      aiInsights: {
        alerts: [
          { type: 'warning', text: "7 SKUs need immediate attention", icon: "⚠️" },
          { type: 'danger', text: "3 SKUs have zero sales in 30 days", icon: "⛔" }
        ],
        nextUpdate: "May 5, 2024",
        skuDetails: [
          { sku: "#ADD_002", insight: "Likely to go out of stock by May" },
          { sku: "#ADD_010", insight: "High return rate detected (12%)" }
        ]
      },
      productList: [
        { id: 101, name: "Ultraboost 22", sku: "#SKU_101", price: "$180", stock: 45 },
        { id: 102, name: "Stan Smith Classic", sku: "#SKU_102", price: "$95", stock: 12 },
        { id: 103, name: "Adicolor Tracksuit", sku: "#SKU_103", price: "$75", stock: 8 }
      ]
    },
    {
      id: 2,
      name: "Apple",
      logo: "",
      description: "Innovation in consumer electronics and software.",
      products: 45,
      website: "https://apple.com",
      status: "Active",
      featured: true,
      owner: "Platform",
      vendorName: "",
      verificationStatus: "Verified",
      allowedCategories: ["Electronics", "Accessories"],
      restrictedCategories: [],
      isInternalOnly: false,
      aiInsights: {
        alerts: [
          { type: 'success', text: "Inventory health is optimal", icon: "✅" },
          { type: 'warning', text: "New model launch pending review", icon: "⚠️" }
        ],
        nextUpdate: "May 6, 2024",
        skuDetails: [
          { sku: "#APL_099", insight: "Top performing SKU this month" },
          { sku: "#APL_045", insight: "Price competitiveness: High" }
        ]
      },
      productList: [
        { id: 201, name: "iPhone 15 Pro", sku: "#SKU_201", price: "$999", stock: 20 },
        { id: 202, name: "MacBook Air M2", sku: "#SKU_202", price: "$1199", stock: 5 }
      ]
    },
    {
      id: 3,
      name: "Dyson",
      logo: "",
      description: "Technology company specializing in household appliances.",
      products: 28,
      website: "https://dyson.com",
      status: "Pending",
      featured: false,
      owner: "Vendor",
      vendorName: "HomeTech Solutions",
      verificationStatus: "Unverified",
      allowedCategories: ["Appliances"],
      restrictedCategories: ["Toys"],
      isInternalOnly: true,
      aiInsights: {
        alerts: [
          { type: 'danger', text: "Verification docs expired", icon: "⛔" }
        ],
        nextUpdate: "May 4, 2024",
        skuDetails: [
          { sku: "#DYS_001", insight: "Pending warranty verification" }
        ]
      },
      productList: [
        { id: 301, name: "V15 Detect Vacuum", sku: "#SKU_301", price: "$749", stock: 10 }
      ]
    },
    {
      id: 4,
      name: "Restricted Brand",
      logo: "",
      description: "A brand with restricted access.",
      products: 0,
      website: "https://example.com",
      status: "Inactive",
      featured: false,
      owner: "Platform",
      vendorName: "",
      verificationStatus: "Restricted",
      allowedCategories: ["Misc"],
      restrictedCategories: ["All"],
      isInternalOnly: false,
      aiInsights: {
        alerts: [
          { type: 'danger', text: "Brand under restriction policy", icon: "⛔" }
        ],
        nextUpdate: "N/A",
        skuDetails: []
      },
      productList: []
    },
  ]);

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const selectedBrand = rows.find(r => r.id === selectedBrandId) || rows[0];

  return (
    <>
      <div className="main_title">
        <h1>Manage Brands
        </h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Brands

        </p>
      </div>
      <div className="table_flex">
        <div className="lt">

          <div className="cards">
            <div className="table_header">
              <div className="left_s">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search ..."
                />
                <div className="form">
                  <div className="control_group">
                    <input type="date" />
                  </div>
                </div>
              </div>
              <div className="right_s">
                <Button
                  className="btn btn_grey"
                >
                  Import
                </Button>
                <Button
                  className="btn btn_primary"
                  onClick={() => setOpenModal(true)}
                >
                  <AddIcon /> Add Brand
                </Button>
              </div>
            </div>

            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Identity</TableCell>
                    <TableCell>Ownership</TableCell>
                    <TableCell>Category Scope</TableCell>
                    <TableCell>Products</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell >Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {rows.map((row) => (
                    <React.Fragment key={row.id}>
                      <TableRow
                        hover
                        selected={selectedBrandId === row.id}
                        onClick={() => setSelectedBrandId(row.id)}
                        style={{ cursor: 'pointer' }}
                      >

                        {/* Identity */}
                        <TableCell>
                          <div className="brand_cell">
                            <div className="brand_avatar">
                              {row.logo ? <img src={row.logo} alt={row.name} style={{ width: '100%', borderRadius: '50%' }} /> : row.name.charAt(0)}
                            </div>
                            <div className="brand_info max_c2">
                              <b>{row.name}</b>
                              {row.featured && <span className="featured">Featured</span>}
                              <p style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>{row.description}</p>
                            </div>
                          </div>
                        </TableCell>

                        {/* Ownership */}
                        <TableCell>
                          <div>
                            <span className={`owner_chip ${row.owner.toLowerCase()}`}>
                              {row.owner}
                            </span>
                            {row.owner === "Vendor" && (
                              <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>
                                Vendor: <b>{row.vendorName}</b>
                              </div>
                            )}
                          </div>
                        </TableCell>
                        {/* Category Scope */}
                        <TableCell>
                          <div className="category_scope">
                            <div className="cat_list">
                              <small>Allowed:</small>
                              {row.allowedCategories.map((cat, index) => (
                                <span key={index} className="cat_tag">{cat}</span>
                              ))}
                            </div>
                            {row.restrictedCategories.length > 0 && (
                              <div className="cat_list" style={{ marginTop: '8px' }}>
                                <small>Restricted:</small>
                                {row.restrictedCategories.map((cat, index) => (
                                  <span key={index} className="cat_tag restricted">{cat}</span>
                                ))}
                              </div>
                            )}
                          </div>
                        </TableCell>

                        {/* Products Count */}
                        <TableCell>
                          <Button
                            className="btn btn_primary sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedRow(expandedRow === row.id ? null : row.id);
                            }}
                          >
                            View ({row.products})
                          </Button>
                        </TableCell>

                        {/* Status */}
                        <TableCell>
                        <SwitchToggle/>
                        </TableCell>

                        {/* Actions */}
                        <TableCell>
                          <div className="table_actions v2" onClick={(e) => e.stopPropagation()}>
                            <IconButton onClick={() => setOpenModal(true)}>
                              <img src="/static/images/edit2_icon.svg" alt="Edit" />
                            </IconButton>

                            <IconButton>
                              <img src="/static/images/trash2_icon.svg" alt="Delete" />
                            </IconButton>
                          </div>
                        </TableCell>

                      </TableRow>

                      {/* Expanded Product View */}
                      {expandedRow === row.id && (
                        <TableRow>
                          <TableCell colSpan={7} style={{ padding: '0 20px 20px' }}>
                            <Box className="expand_table_wrap">
                              <div className="expand_header">
                                <h6>Products for {row.name}</h6>
                                {/* <Button className="btn btn_light sm" onClick={() => navigate("/manage-products")}>Manage All</Button> */}
                              </div>
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Product Name</TableCell>
                                    <TableCell>SKU</TableCell>
                                    <TableCell>Price</TableCell>
                                    <TableCell>Stock</TableCell>
                                    <TableCell>Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {row.productList.map((prod) => (
                                    <TableRow key={prod.id}>
                                      <TableCell><b>{prod.name}</b></TableCell>
                                      <TableCell>{prod.sku}</TableCell>
                                      <TableCell>{prod.price}</TableCell>
                                      <TableCell>
                                        <span className={prod.stock < 10 ? "low_stock" : ""}>
                                          {prod.stock} Units
                                        </span>
                                      </TableCell>
                                      <TableCell>
                                        <IconButton size="small">
                                          <img src="/static/images/edit2_icon.svg" alt="Edit" style={{ width: '14px' }} />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                  {row.productList.length === 0 && (
                                    <TableRow>
                                      <TableCell colSpan={5} style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
                                        No products found for this brand.
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </Box>
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))}
                </TableBody>

              </Table>
            </TableContainer>
          </div>
        </div>
        <div className="rt">
          <div className="ai_panel">
            <h4>AI Insights - <b>{selectedBrand.name}</b></h4>

            {selectedBrand.aiInsights.alerts.map((alert, idx) => (
              <div key={idx} className={`ai_alert ${alert.type}`}>
                <span className="icon">{alert.icon}</span>
                <p>
                  <b>{alert.text}</b>
                </p>
              </div>
            ))}

            <small className="ai_update">
              Next updated ETA: <b>{selectedBrand.aiInsights.nextUpdate}</b>
            </small>

            <div className="ai_sku_list">
              {selectedBrand.aiInsights.skuDetails.map((sku, idx) => (
                <div key={idx} className="ai_sku_row">
                  <div className="ai_sku_info">
                    <h5>{sku.sku}</h5>
                    <p>{sku.insight}</p>
                  </div>
                  <button className="ai_action_btn">Actions ▾</button>
                </div>
              ))}
              {selectedBrand.aiInsights.skuDetails.length === 0 && (
                <p style={{ fontSize: '12px', color: '#999', textAlign: 'center', marginTop: '20px' }}>No SKU specific insights available.</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <AddBrand
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageBrands;
